import $ from 'jquery';

const $achievementTabs = $('.js-achievement-tabs a');
const $achievementCard = $('.js-achievements-card');
const $expandCardButton = $('.js-expand-achievements-card');
const $achievementNotificationWrapper = $(
	'#js-achievement-notification-wrapper'
);

// $achievementTabs.on('click', function (e) {
// 	e.preventDefault();
// 	$(this).tab('show');
// 	$achievementCard.removeClass('mh-auto');
// 	$expandCardButton.addClass('d-flex');
// 	$expandCardButton.removeClass('d-none');
// });

$expandCardButton.click(function (e) {
	e.preventDefault();
	$achievementCard.addClass('mh-auto');
	$(this).removeClass('d-flex');
	$(this).addClass('d-none');
});

const setAchievementContent = function (content) {
	$achievementNotificationWrapper.html(content);
	const $achievementNotification = $('.achievement-notification');
	setTimeout(() => $achievementNotification.removeClass('hidden'), 0);
	$closeNotificationButton = $('.js-close-achievement-notification');

	$closeNotificationButton.click((e) => {
		e.preventDefault();
		$achievementNotification.addClass('hidden');
		setTimeout(() => $achievementNotification[0].remove(), 300);
		setTimeout(fetchAchievements, 1000);
	});
};

const fetchAchievements = function () {
	if (document.hasFocus() && $achievementNotificationWrapper.length) {
		$achievementNotificationWrapper;
		$.ajax({
			url: '/achievement',
			method: 'GET',
		}).done((response) => {
			if (response.notification_content)
				setAchievementContent(response.notification_content);
		});
	}
};

// fetchAchievements();
// setInterval(fetchAchievements, 15000);
